

<h1 class="page-header">Panel de inicio </h1>
<panel noButton="true" class="mb-5">
@if(panels){
  <div class="row">
    <span class="fs-5 fw-bolder mb-2">Información General</span>
    <div class="col-xl-3 col-md-6">
      <div class="widget widget-stats bg-cyan-600">
        <div class="stats-icon stats-icon-md"><i class="fa fa-clipboard fa-fw"></i></div>
        <div class="stats-content">
          <div class="stats-title text-white">Total Movimientos</div>
          <div class="stats-number text-white">{{panels?.allPeriod?.request.count}}</div>
          <div class="stats-progress progress"><div class="progress-bar" style="width: 100%;"></div></div>
          <div class="stats-desc text-ellipsis text-white">Total movimientos</div>
        </div>
      </div>
    </div>
    <div class="col-xl-3 col-md-6">
      <div class="widget widget-stats bg-gray-600">
        <div class="stats-icon stats-icon-md "><i class="fa fa-user-clock fa-fw"></i></div>
        <div class="stats-content">
          <div class="stats-title text-white">En revisión</div>
          <div class="stats-number text-white">{{panels?.allPeriod?.inReview.count}}</div>
          <div class="stats-progress progress"><div class="progress-bar" [style]="'width:' + panels?.allPeriod?.inReview.percentage + '%'"></div></div>
          <div class="stats-desc text-ellipsis text-white">Total movimientos en revisión ({{panels?.allPeriod?.inReview.percentage | number:'1.0-2'}}%)</div>
        </div>
      </div>
    </div>
    <div class="col-xl-3 col-md-6">
      <div class="widget widget-stats bg-red-600">
        <div class="stats-icon stats-icon-md"><i class="fa fa-user-times fa-fw"></i></div>
        <div class="stats-content">
          <div class="stats-title text-white">Rechazados</div>
          <div class="stats-number text-white">{{panels?.allPeriod?.rejections.count}}</div>
          <div class="stats-progress progress"><div class="progress-bar" [style]="'width:' + panels?.allPeriod?.rejections.percentage + '%'"></div></div>
          <div class="stats-desc text-ellipsis text-white">Total movimientos rechazados ({{panels?.allPeriod?.rejections.percentage | number:'1.0-2'}}%)</div>
        </div>
      </div>
    </div>
    <div class="col-xl-3 col-md-6">
      <div class="widget widget-stats bg-teal-600">
        <div class="stats-icon stats-icon-md"><i class="fa fa-user-plus fa-fw"></i></div>
        <div class="stats-content">
          <div class="stats-title text-white">Aprobados</div>
          <div class="stats-number text-white">{{panels?.allPeriod?.approvals.count}}</div>
          <div class="stats-progress progress"><div class="progress-bar" [style]="'width:' + panels?.allPeriod?.approvals.percentage + '%'"></div></div>
          <div class="stats-desc text-ellipsis text-white">Total movimientos aprobados ({{panels?.allPeriod?.approvals.percentage | number:'1.0-2'}}%)</div>
        </div>
      </div>
    </div>
  </div>
  <div class="row mb-5">
    <span class="fs-5 fw-bolder mb-2">Detalle de Solicitudes</span>
    <div class="col-xl-3 col-md-6">
      <div class="widget widget-stats bg-blue-600">
        <div class="stats-icon stats-icon-md "><i class="fa fa-user-plus fa-fw"></i></div>
        <div class="stats-content">
          <div class="stats-title text-white">Incorporación</div>
          <div class="stats-number text-white">{{panels?.details?.incorporation.count}}</div>
          <div class="stats-progress progress"><div class="progress-bar" [style]="'width:' + panels?.details?.incorporation.percentage + '%'"></div></div>
          <div class="stats-desc text-ellipsis text-white">Total incorporaciones ({{panels?.details?.incorporation.percentage | number:'1.0-2'}}%)</div>
        </div>
      </div>
    </div>
    <div class="col-xl-3 col-md-6">
      <div class="widget widget-stats bg-red-600">
        <div class="stats-icon stats-icon-md"><i class="fa fa-user-times fa-fw"></i></div>
        <div class="stats-content">
          <div class="stats-title text-white">Exclusión</div>
          <div class="stats-number text-white">{{panels?.details?.exclusion.count}}</div>
          <div class="stats-progress progress"><div class="progress-bar" [style]="'width:' + panels?.details?.exclusion.percentage + '%'"></div></div>
          <div class="stats-desc text-ellipsis text-white">Total exclusiones ({{panels?.details?.exclusion.percentage | number:'1.0-2'}}%)</div>
        </div>
      </div>
    </div>
    <div class="col-xl-3 col-md-6">
      <div class="widget widget-stats bg-lime-600">
        <div class="stats-icon stats-icon-md"><i class="fa fa-angle-double-left fa-fw"></i></div>
        <div class="stats-content">
          <div class="stats-title text-white">Transferencia Entrada</div>
          <div class="stats-number text-white">{{panels?.details?.transferIn.count}}</div>
          <div class="stats-progress progress"><div class="progress-bar" [style]="'width:' + panels?.details?.transferIn.percentage + '%'"></div></div>
          <div class="stats-desc text-ellipsis text-white">Total transferencias entrantes ({{panels?.details?.transferIn.percentage | number:'1.0-2'}}%)</div>
        </div>
      </div>
    </div>
    <div class="col-xl-3 col-md-6">
      <div class="widget widget-stats bg-orange-600">
        <div class="stats-icon stats-icon-md"><i class="fa fa-angle-double-right fa-fw"></i></div>
        <div class="stats-content">
          <div class="stats-title text-white">Transferencia Salida</div>
          <div class="stats-number text-white">{{panels?.details?.transferOut.count}}</div>
          <div class="stats-progress progress"><div class="progress-bar" [style]="'width:' + panels?.details?.transferOut.percentage + '%'"></div></div>
          <div class="stats-desc text-ellipsis text-white">Total transferencias salientes ({{panels?.details?.transferOut.percentage | number:'1.0-2'}}%)</div>
        </div>
      </div>
    </div>
  </div>
}
</panel>
<!-- end pane -->
